import Vue from "vue";
import Router from "vue-router";
import Layout from "./views/layout/Layout.vue";
import LayoutBlank from "./views/layout/LayoutBlank.vue";

Vue.use(Router);
export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "",
      component: Layout,
      children: [
        {
          path: "/",
          name: "Home",
          component: () => import(/* webpackChunkName: "about" */ "@/views/pages/Home")
        }
      ]
    },
    {
      path: "/pages",
      component: LayoutBlank,
      children: [
        {
          path: "/term-and-condition",
          name: "TermAndCondition",
          component: () => import(/* webpackChunkName: "about" */ "@/views/pages/TermAndCondition")
        },
        {
          path: "/privacy-policies",
          name: "PrivacyPolicies",
          component: () => import(/* webpackChunkName: "about" */ "@/views/pages/PrivacyPolicies")
        },
        {
          path: "/contact-us",
          name: "ContactUs",
          component: () => import(/* webpackChunkName: "about" */ "@/views/pages/ContactUs")
        }
      ]
    },
    {
      path: "*",
      name: "404Pages",
      component: () => import(/* webpackChunkName: "about" */ "@/views/error/404Pages")
    }
  ]
});
